import type {
  LocalPreference,
  LocalOnceData,
  LocalKeepData,
  KeyOfLocalOnceData,
  KeyOfLocalKeepData,
} from "./tools/types";
import liuApi from "../liu-api";
import liuEnv from "../liu-env";
import ider from "../basic/ider";

function _getPreKey() {
  const hasBackend = liuEnv.hasBackend()
  const key = hasBackend ? "cloud-preference" : "local-preference"
  return key
}

function getPreference(): LocalPreference {
  const key = _getPreKey()
  const res = liuApi.getStorageSync<LocalPreference>(key) || {}
  return res
}

function setPreference<T extends keyof LocalPreference>(
  key: T, data: LocalPreference[T]
) {
  const localP = getPreference()
  localP[key] = data

  const key2 = _getPreKey()
  liuApi.setStorageSync(key2, localP)
}

function setAllPreference(obj: LocalPreference) {
  const key = _getPreKey()
  liuApi.setStorageSync(key, obj)
}

function clearPreference() {
  const key = _getPreKey()
  liuApi.removeStorageSync(key)
}


/********** 一次性、不依赖登录态的数据 ********/
function getOnceData(): LocalOnceData {
  const res = liuApi.getStorageSync<LocalOnceData>("local-once-data") || {}
  return res
}

function setOnceData(key: KeyOfLocalOnceData, data: any) {
  const localData = getOnceData()
  localData[key] = data
  const res = liuApi.setStorageSync("local-once-data", localData)
}

function removeOnceDataWhileLogging() {
  const localData = getOnceData()
  const keys: KeyOfLocalOnceData[] = [
    "client_key",
    "enc_client_key",
    "githubOAuthState",
    "googleOAuthState",
    "wxGzhOAuthState",
    "goto",
    "gotoStamp",
  ]
  for (let i = 0; i < keys.length; i++) {
    const k = keys[i]
    localData[k] = undefined
  }
  liuApi.setStorageSync("local-once-data", localData)
}


/********** data which is not changed by context ********/
function getKeepData(): LocalKeepData {
  const res = liuApi.getStorageSync<LocalKeepData>("local-keep-data") || {}
  return res
}

function setKeepData(key: KeyOfLocalKeepData, data: any) {
  const localData = getKeepData()
  localData[key] = data
  liuApi.setStorageSync("local-keep-data", localData)
}


function setClientId(clientId: string) {
  setKeepData("client_id", clientId)
}


function getClientId() {
  const localData = getKeepData()
  let clientId = localData.client_id
  if (clientId) return clientId
  clientId = ider.createClientId()
  setClientId(clientId)
  return clientId
}



/*********** 是否具备后端并且已登录 ********/
function hasLoginWithBackend() {
  const {
    local_id,
    serial,
    token,
  } = getPreference()
  if (local_id && serial && token) return true
  return false
}


export default {
  getPreference,
  setPreference,
  setAllPreference,
  clearPreference,
  getOnceData,
  setOnceData,
  removeOnceDataWhileLogging,
  getKeepData,
  setKeepData,
  getClientId,
  setClientId,
  hasLoginWithBackend,
}